import React from "react";
import { useIntl } from "react-intl";
import { useMagentoConfig } from "@Src_main/utils/useMagentoConfig";
export var Price = _ref => {
  var {
    value = 0,
    addFrom = false,
    gratisIf0 = false,
    doublePrecision = false
  } = _ref;
  var {
    locale,
    formatMessage
  } = useIntl();
  var {
    currencyCode
  } = useMagentoConfig();
  if (!currencyCode) {
    return null;
  }
  var numericValue = Number(value);
  var formattedValue = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: doublePrecision ? 2 : 0,
    maximumFractionDigits: 2
  }).format(value);
  if (gratisIf0 && numericValue === 0) {
    return "gratis";
  }
  var priceText = "".concat(addFrom ? formatMessage({
    id: "from"
  }) : "").concat(formattedValue);
  return /*#__PURE__*/React.createElement("span", null, priceText);
};
export var PriceWithDiscount = _ref2 => {
  var {
    value = 0,
    currencyCode = "EUR",
    addFrom = false,
    doublePrecision = false,
    discountedPrice = null
  } = _ref2;
  var isDiscounted = discountedPrice !== null && parseFloat(discountedPrice) < parseFloat(value);
  var price = /*#__PURE__*/React.createElement("span", {
    className: "weglotExclude uk-margin-xsmall-left ".concat(isDiscounted ? "uk-text-small uk-text-strikethrough uk-text-emphasis coupon-original-price" : "")
  }, /*#__PURE__*/React.createElement(Price, {
    value: value,
    currencyCode: currencyCode,
    addFrom: addFrom,
    doublePrecision: doublePrecision
  }));
  var discountedPriceFormatted = isDiscounted ? /*#__PURE__*/React.createElement("span", {
    className: "weglotExclude uk-text-bold uk-margin-xsmall-left"
  }, /*#__PURE__*/React.createElement(Price, {
    value: discountedPrice,
    currencyCode: currencyCode,
    addFrom: addFrom,
    doublePrecision: doublePrecision
  })) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, price, discountedPriceFormatted);
};
export default Price;